// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"220":"f6d006ec","377":"77fa1c81"}[chunkId] + ".css";
};